import { CustomValidators } from '../../../../shared/validators/custom.validator';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { extractAttributeFromTag, urlValidation } from 'src/app/common/function';
import { Component, EventEmitter, Input, OnInit, Output, inject, Renderer2, ElementRef } from '@angular/core';
import { ArticleBlock } from '../../../../models/article';

@Component({
  selector: 'app-article-video',
  templateUrl: './article-video.component.html',
  styleUrls: ['./article-video.component.scss'],
})
export class ArticleVideoComponent implements OnInit {
  @Output() blockElementChange = new EventEmitter<ArticleBlock>();

  @Output() onUrlValueChange = new EventEmitter<boolean>();

  @Input() set blockElement(value: ArticleBlock) {
    this._blockElement = value;
    this.videoUrl = this._blockElement.data;
    this.isYoutubeUrl = this.matchYoutubeUrl(this.videoUrl);
    this.value = this.sanitizer.bypassSecurityTrustResourceUrl(this.isYoutubeUrl ? this.convertToEmbedUrl(this.isYoutubeUrl) : this.videoUrl);
  }
  constructor(private renderer: Renderer2, private el: ElementRef) { }


  private sanitizer = inject(DomSanitizer);

  get blockElement() {
    return this._blockElement;
  }

  private _blockElement: ArticleBlock;

  videoUrl: any;
  value: SafeResourceUrl;
  isYoutubeUrl: string = '';
  isValidUrl: boolean = true;

  ngOnInit(): void { }

  onChange(e: string) {
    this.isValidUrl = urlValidation(e);
    this.onUrlValueChange.emit(this.isValidUrl);
    this.blockElement.data = e;
    this.isYoutubeUrl = this.matchYoutubeUrl(e);
    this.value = this.sanitizer.bypassSecurityTrustResourceUrl(this.isYoutubeUrl ? this.convertToEmbedUrl(this.isYoutubeUrl) : e);


    this.blockElementChange.emit(this.blockElement);
  }

  ngOnChanges(): void {
    setTimeout(() => {
      if (this.blockElement?.isActiveForEdit) {
        const editorElement = this.el.nativeElement.querySelector('.video-input');
        this.renderer.setAttribute(editorElement, 'autofocus', 'true');
        editorElement.focus();
      }
    }, 700);
  }

  matchYoutubeUrl(url) {
    var p =
      /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
    if (url.match(p)) {
      return url.match(p)[1];
    }
    return '';
  }

  convertToEmbedUrl(videoId: string): string | null {
    return `https://www.youtube.com/embed/${videoId}`;
  }
}
